// extracted by mini-css-extract-plugin
export default {"header":"styles_header__rbjGf","logo":"styles_logo__N64h7","closeBtn":"styles_closeBtn__aDeCV","icon":"styles_icon__RGUmx"};